import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

const EditDialog = ({ editDialog, setEditDialog, handleExitAgree }) => {
  return (
    <Dialog open={editDialog} onClose={() => setEditDialog(false)}>
      <DialogTitle>Confirm Exit</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you really want to exit without saving?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEditDialog(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={() => handleExitAgree('discard')} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialog;
